export default ({ request }) => ({
  orderInspectionListApi(data = {}) {
    return request({
      url: '/factory/order/inspection/list',
      method: 'post',
      data,
    })
  },
  orderInspectionSaveApi(data = {}) {
    return request({
      url: '/factory/order/inspection/save',
      method: 'post',
      data,
    })
  },
  orderInspectionDetailApi(data = {}) {
    return request({
      url: '/factory/order/inspection/detail',
      method: 'post',
      data,
    })
  },
  orderInspectionBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/inspection/batchDel',
      method: 'post',
      data,
    })
  },
})
